import getConfig from "next/config"

const { publicRuntimeConfig } = getConfig()


export function localFileSource(relativeUrl) {
  return publicRuntimeConfig.PROTOCOL! + publicRuntimeConfig.HOSTNAME! + relativeUrl
}
